import { useMemo } from 'react'
import useQueryGetUserMonthAvailability, { IUserPositionDay } from '@/api/user/getUserMonthAvailability.ts'
import { buildAvailabilityMap, isFutureMonth, resolveCalendarView } from '@/util/positionAvailability.ts'

type DaysToMap = (days: IUserPositionDay[]) => Map<string, IUserPositionDay>

// 달력이 보여줄 달과 기록. 다른 달로 넘겨도 새 달의 기록이 올 때까지 직전 달을 그대로 보여 주다가 한 번에 바꾼다.
const useMonthAvailabilityView = (
    userId: number,
    targetMonth: Date,
    enabled: boolean,
    toMap: DaysToMap = buildAvailabilityMap
) => {
    const year = targetMonth.getFullYear()
    const month = targetMonth.getMonth() + 1
    const isFuture = isFutureMonth(year, month)
    const query = useQueryGetUserMonthAvailability(userId, year, month, enabled && !isFuture)
    const view = resolveCalendarView({ year, month }, query.data)
    const viewMonth = useMemo(
        () => new Date(view.month.year, view.month.month - 1, 1),
        [view.month.year, view.month.month]
    )
    const availability = useMemo(() => toMap(view.days), [toMap, view.days])

    return {
        viewMonth,
        availability,
        isLoading: query.isLoading,
        isError: query.isError,
        isBusy: query.isPlaceholderData && !isFuture
    }
}

export default useMonthAvailabilityView
